<div class='container'>
  <h1>Access Denied</h1>

  <hr />
  <p>You do not have permission to view this page.</p>
</div>
